// BaseURLs
export const BASE_URL = "http://ec2-3-88-113-28.compute-1.amazonaws.com:8888"; //local URL for nginx redirectgit
// export const BASE_URL = "https://trading-da.varcity.io/api/"; // LIve URL

export const BASE_URL_USER = BASE_URL + "user2/";
export const BASE_URL_ORDERS = BASE_URL + "orders2/";
export const BASE_URL_ALERTS = BASE_URL + "alerts2/";
export const BASE_URL_MARKETDATA = BASE_URL + "marketdata2/";

export const API_END_POINTS = {
  // User Endpoints
  login: BASE_URL+"/auth/token/obtain/",
  registerNewUser: BASE_URL_USER + "register-new-user",
  forgotPasswordApi: BASE_URL_USER + "send-forgot-password-email",
  getUserProfile: BASE_URL_USER + "get-profile",
  changePassword: BASE_URL_USER + "changePassword",
  logout: BASE_URL + "logout",
  addBusiness: BASE_URL+"/business/crud/",
  addPost: BASE_URL+"/websitepost/create/",
  getListing:BASE_URL+"/business/crud/",
  getPisting:BASE_URL+"/websitepost/get/",
  updatePosting:BASE_URL+"/websitepost/update/",
  updateListing:BASE_URL+"/business/crud/",
 
// keywords
keywords:BASE_URL+"/business/keyword",
};
